<template>
  <v-container
    id="user-profile-view"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <material-card
          color="primary"
          icon="mdi-exclamation-thick"
        >
          <template #title>
            Player Highlights
          </template>

          <template>
            <v-container class="fill-height">
              <v-row justify="center">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/uMcU4LGb9KY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                />
              </v-row>
            </v-container>
          </template>
        </material-card>
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <app-card class="mt-4 text-center">
          <v-img
            class="rounded-circle elevation-6 mt-n12 d-inline-block"
            src="https://www.valpo.edu/esports/files/2021/02/20210206-JLH-Esports-Portraits-007.jpg"
            width="400"
          />

          <v-card-text class="text-center">
            <h6 class="text-h6 mb-2 text--secondary">
              Player
            </h6>

            <h4 class="text-h4 mb-3 text--primary">
              John Faker
            </h4>

            <p class="text--secondary">
              I am an amazing esports player who loves to compete, win, and have a good time. I was born in Russia.
            </p>

            <p class="text--secondary">
              Age: 27
            </p>
            <p class="text--secondary">
              Birth: 24-02-1993
            </p>
            <p class="text--secondary">
              Sex: Man
            </p>
            <v-col>
              <v-btn
                class="mr-0"
                color="primary"
                min-width="100"
                rounded
              >
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <v-btn
                class="mr-0"
                color="primary"
                min-width="100"
                rounded
              >
                <v-icon>mdi-twitch</v-icon>
              </v-btn>
              <v-btn
                class="mr-0"
                color="primary"
                min-width="100"
                rounded
              >
                <v-icon>mdi-discord</v-icon>
              </v-btn>
            </v-col>
          </v-card-text>
        </app-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default { name: 'UserProfileView' }
</script>
